<template>
  <div>
    <div class="expandableContainer pa-5">
      <div style="position: relative">
        <v-tooltip right>
          <v-btn
            v-show="!modals.showAddUserForm"
            style="position: absolute; top: -30px; left: -30px"
            fab
            dark
            small
            color="gradiente"
            slot="activator"
            @click="
              () => {
                this.modals.showAddUserForm = true
              }
            "
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear credenciales</span>
        </v-tooltip>
        <div v-show="modals.showAddUserForm">
          <div
            class="pa-1"
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              overflow: scroll;
            "
          >
            <v-text-field
              style="width: 100%; max-width: 300px"
              label="Nombre de aplicación"
              v-model="formUserApi.userApiName"
            />
            <span class="error--text" v-show="formUserApi.errorUserApiName">
              Agrega un nombre
            </span>
            <v-text-field
              style="width: 100%; max-width: 300px"
              label="Descripción"
              v-model="formUserApi.userApiDescription"
            />
            <span
              class="error--text"
              v-show="formUserApi.errorUserApiDescription"
            >
              Agrega una descripción
            </span>
            <div style="display: flex; width: 100%; max-width: 300px">
              <v-btn
                class="modal_button mr-1 pa-1"
                @click="
                  () => {
                    modals.showAddUserForm = false
                    formUserApi = {
                      errorUserApiName: false,
                      errorUserApiDescription: false,
                      userApiName: '',
                      userApiDescription: '',
                    }
                  }
                "
              >
                Cancelar
              </v-btn>
              <v-btn
                class="modal_button pa-1"
                color="primary"
                @click="createUser"
              >
                Agregar
              </v-btn>
            </div>
          </div>
        </div>
        <div
          v-show="apiUsers.length === 0 && modals.showAddUserForm === false"
          class="asd"
        >
          <p>
            No hay registro de usuarios para hacer uso de la api de skolable,
            para obtener más detalle te sugerimos navegar a la
            <a href="https://docs.skolable.com" target="_blank">documentación</a
            >.
          </p>
        </div>
        <v-data-table
          v-show="apiUsers.length !== 0 && modals.showAddUserForm === false"
          hide-actions
          :headers="[
            {
              text: 'Opciones',
              value: '',
              sortable: false,
            },
            {
              text: 'Nombre',
              value: '',
              sortable: false,
            },
            {
              text: 'Descripción',
              value: '',
              sortable: false,
            },
            {
              text: 'ClientId',
              value: '',
              sortable: false,
            },
          ]"
          :items="apiUsers"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">
              <v-tooltip right>
                <v-btn
                  icon
                  slot="activator"
                  @click="deleteApiUser(props.item.clientId)"
                >
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
                <span>Eliminar credenciales</span>
              </v-tooltip>
              <v-tooltip right>
                <v-btn
                  icon
                  slot="activator"
                  @click="renovateApiUser(props.item.clientId)"
                >
                  <v-icon color="primary">sync</v-icon>
                </v-btn>
                <span>Renovar credenciales</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left">
              {{ props.item.applicationName }}
            </td>
            <td class="text-xs-left">
              {{ props.item.description }}
            </td>
            <td class="text-xs-left">
              {{ props.item.clientId }}
            </td>
          </template>
        </v-data-table>
        <div v-show="apiUsers.length !== 0" class="asd">
          <p>
            Te sugerimos navegar a la
            <a href="https://docs.skolable.com" target="_blank">documentación</a
            >.
          </p>
        </div>
      </div>
    </div>
    <v-dialog v-model="modals.showAddUserResponseDialog" max-width="600">
      <v-card>
        <v-card-title class="headline">
          Atención
          <v-spacer></v-spacer>
          <v-icon color="orange">warning</v-icon>
        </v-card-title>
        <v-card-text>
          <div class="alert-response subheading">
            <p class="red--text mb-1">
              <b>
                Guarda la siguiente información, solo será visible esta vez.
              </b>
            </p>
            <p>
              secret: <b>{{ apiUserResponse.clientSecret }}</b>
            </p>
            <p>
              authorizationCode: <b>{{ apiUserResponse.authorizationCode }}</b>
            </p>
            <p>
              clientId: <b>{{ apiUserResponse.clientId }}</b>
            </p>
            <p>
              expiresIn: <b>{{ msToDays(apiUserResponse.expiresIn) }}</b> días
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            flat="flat"
            @click="
              () => {
                modals.showAddUserResponseDialog = false
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modals.showRenovateUserResponseDialog" max-width="600">
      <v-card>
        <v-card-title class="headline">
          Atención
          <v-spacer></v-spacer>
          <v-icon color="orange">warning</v-icon>
        </v-card-title>
        <v-card-text>
          <div class="alert-response subheading">
            <p class="red--text mb-1">
              <b>
                Guarda la siguiente información, solo será visible esta vez.
              </b>
            </p>
            <p>
              authorizationCode: <b>{{ apiUserResponse.authorizationCode }}</b>
            </p>
            <p>
              clientId: <b>{{ apiUserResponse.clientId }}</b>
            </p>
            <p>
              expiresIn: <b>{{ msToDays(apiUserResponse.expiresIn) }}</b> días
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            flat="flat"
            @click="
              () => {
                modals.showRenovateUserResponseDialog = false
              }
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Confirm
      title="Eliminar credenciales"
      description="Al eliminar este registro, se eliminará el acceso para este usuario."
      ok-text="Aceptar"
      cancel-text="Cerrar"
      :show="modals.showConfirmDelete"
      @change="onConfirm"
    />
    <Loading v-model="modals.loading" text="Cargando..." />
    <Error v-model="modals.showError" :text="modals.errorText" />
    <Success v-model="modals.showSuccess" :text="modals.successText" />
  </div>
</template>

<script>
import ConfirmAccept from '../../Dialogs/Alert.vue'
import Confirm from '../../Dialogs/confirm_new_ui.vue'
import Error from '../../Dialogs/Error.vue'
import Loading from '../../Dialogs/Loading.vue'
import Success from '../../Dialogs/Success.vue'

export default {
  components: {
    ConfirmAccept,
    Loading,
    Confirm,
    Error,
    Success,
  },
  mounted() {
    this.getApiUsers()
  },
  data: () => ({
    apiUsers: [],
    modals: {
      showSuccess: false,
      showError: false,
      successText: '',
      errorText: '',
      tempClientId: '',
      loading: false,
      showAddUserForm: false,
      showAddUserResponseDialog: false,
      showRenovateUserResponseDialog: false,
      showConfirmDelete: false,
    },
    apiUserResponse: {
      clientId: '',
      clientSecret: '',
      authorizationCode: '',
      expiresIn: 0,
    },
    formUserApi: {
      errorUserApiName: false,
      errorUserApiDescription: false,
      userApiName: '',
      userApiDescription: '',
    },
  }),
  methods: {
    msToDays(ms = 0) {
      return Math.floor(ms / 8.64e7)
    },
    renovateApiUser(clientId) {
      this.modals.loading = true
      this.$store
        .dispatch('apiUser/regenerateUser', clientId)
        .then(({ data }) => {
          this.apiUserResponse = data
          this.modals.showRenovateUserResponseDialog = true
          this.modals.showSuccess = true
          this.modals.successText = 'Éxito al renovar credenciales'
          this.getApiUsers()
        })
        .catch((e) => {
          console.log(e)
          this.modals.showError = true
          this.modals.errorText = 'Error al renovar credenciales'
        })
        .finally(() => {
          this.modals.loading = false
        })
    },
    onConfirm(e) {
      this.modals.showConfirmDelete = false
      if (e === false) return

      this.modals.loading = true
      this.$store
        .dispatch('apiUser/deleteUser', this.modals.tempClientId)
        .then(({ data }) => {
          this.apiUserResponse = data
          this.modals.showSuccess = true
          this.modals.successText = 'Éxito al eliminar credenciales'
          this.getApiUsers()
        })
        .catch((e) => {
          if (e.response.status === 400) {
            this.modals.errorText =
              'clientId existe pero no corresponde al colegio'
          } else if (e.response.status === 400) {
            this.modals.errorText = 'clientId no existe'
          } else {
            this.modals.errorText = 'Error al eliminar credenciales'
          }

          this.modals.showError = true
        })
        .finally(() => {
          this.modals.loading = false
        })
    },
    deleteApiUser(clientId) {
      this.modals.showConfirmDelete = true
      this.modals.tempClientId = clientId
    },
    createUser() {
      const errorOnName = this.formUserApi.userApiName.trim() === ''
      const errorOnDescription =
        this.formUserApi.userApiDescription.trim() === ''

      this.formUserApi.errorUserApiName = errorOnName
      this.formUserApi.errorUserApiDescription = errorOnDescription

      if (errorOnName || errorOnDescription) return

      this.modals.loading = true
      this.$store
        .dispatch('apiUser/createUser', {
          applicationName: this.formUserApi.userApiName,
          description: this.formUserApi.userApiDescription,
        })
        .then(({ data }) => {
          this.apiUserResponse = data
          this.modals.showAddUserResponseDialog = true
          this.modals.showSuccess = true
          this.modals.successText = 'Éxito al crear credenciales'
          this.getApiUsers()
        })
        .catch((e) => {
          console.log(e)
          this.modals.showError = true
          this.modals.errorText = 'Error al crear credenciales'
        })
        .finally(() => {
          this.modals.loading = false
          this.modals.showAddUserForm = false
          this.formUserApi = {
            errorUserApiDescription: false,
            errorUserApiName: false,
            userApiDescription: '',
            userApiName: '',
          }
        })
    },
    getApiUsers() {
      this.$store
        .dispatch('apiUser/getUsers')
        .then(({ data }) => {
          this.apiUsers = data
        })
        .catch((e) => {
          this.modals.showError = true
          this.modals.errorText = 'Error al solicitar credenciales'
          this.apiUsers = []
        })
    },
  },
}
</script>

<style scoped>
.alert-response p {
  margin: 0px;
}
.modal_button {
  margin: 0;
  width: 50%;
  border-radius: 8px;
  border: 1px solid #cccc;
  color: #272727;
  text-transform: initial !important;
}
</style>
